// The visitor's desktop platform from the user agent — which installer link
// counts as "current". null when neither matches (Linux, mobile, unknown):
// callers then show both platforms, since a guessed single link could be
// the wrong one.
export type Platform = "mac" | "windows"

export const platformLabels: Record<Platform, string> = {
  mac: "macOS",
  windows: "Windows"
}

function detectPlatform(): Platform | null {
  const ua = navigator.userAgent?.toLowerCase() ?? ""
  if (ua.includes("macintosh") || ua.includes("mac os")) return "mac"
  if (ua.includes("windows")) return "windows"
  return null
}

export const userPlatform = detectPlatform()
